import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useRecurrenceData = () => {
  const [data, setData] = useState({
    recurrence_period: 0,
    max: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!verifyTokenExpire()) return;

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${appConfig.apiDomaine}/configurations/recurrence-alert`
      );

      setData({
        recurrence_period: response.data.recurrence_period || 0,
        max: response.data.max || 0,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error, refetch: fetchData };
};
